import { z } from '@harvestiq/zod';

export const sendOptInConfirmationRequestBodySchema = z.object({
  recipientId: z.string().uuid(),
});

export type SendOptInConfirmationRequestBody = z.infer<
  typeof sendOptInConfirmationRequestBodySchema
>;
